import { render, staticRenderFns } from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=template&id=5561579d&scoped=true"
import script from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=style&index=0&id=5561579d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561579d",
  null
  
)

export default component.exports